var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "identityPage" },
    [
      _c("div", { staticClass: "taxTip" }, [
        _vm._v(
          " 根据监管规定，金融机构及其委托代销机构必须对新开户客户开展尽职调查。请您如实确认您的税收居民信息。 "
        )
      ]),
      _c(
        "div",
        { staticClass: "identityType" },
        [
          _c(
            "van-radio-group",
            {
              on: { change: _vm.onChange },
              model: {
                value: _vm.radioChecked,
                callback: function($$v) {
                  _vm.radioChecked = $$v
                },
                expression: "radioChecked"
              }
            },
            _vm._l(_vm.radioItem, function(item) {
              return _c(
                "van-radio",
                {
                  key: item.radioIndex,
                  staticClass: "cosStyle",
                  attrs: { name: item.radioIndex },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "icon",
                        fn: function(props) {
                          return [
                            _c("img", {
                              staticClass: "img-icon",
                              attrs: {
                                src: props.checked
                                  ? _vm.clickedIcon
                                  : _vm.unClickedIcon
                              }
                            })
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                },
                [_vm._v(" " + _vm._s(item.radioTheme) + " ")]
              )
            }),
            1
          )
        ],
        1
      ),
      _vm.showIndexOne
        ? [
            _c("div", { staticClass: "emptyDiv" }),
            _c(
              "van-form",
              [
                _c("van-field", {
                  attrs: {
                    name: "familyName",
                    label: "拼音/英语姓",
                    placeholder: "请输入拼音/英语姓",
                    "input-align": "right",
                    formatter: _vm.formatterEntry,
                    rules: [{ required: true, trigger: "onSubmit" }]
                  },
                  on: { focus: _vm.changeWarnColor },
                  model: {
                    value: _vm.personalObj.familyName,
                    callback: function($$v) {
                      _vm.$set(_vm.personalObj, "familyName", $$v)
                    },
                    expression: "personalObj.familyName"
                  }
                }),
                _c("van-field", {
                  attrs: {
                    name: "lastName",
                    label: "拼音/英语名",
                    placeholder: "请输入拼音/英语名",
                    formatter: _vm.formatterEntry,
                    "input-align": "right",
                    rules: [{ required: true, trigger: "onSubmit" }]
                  },
                  on: { focus: _vm.changeWarnColor },
                  model: {
                    value: _vm.personalObj.lastName,
                    callback: function($$v) {
                      _vm.$set(_vm.personalObj, "lastName", $$v)
                    },
                    expression: "personalObj.lastName"
                  }
                }),
                _c("div", { staticClass: "emptyDiv" }),
                _c("div", { staticClass: "chinaTip" }, [
                  _c("div", { staticClass: "aboutSure" }, [
                    _vm._v(
                      " 本人确认信息真实、准确和完整，且当上述信息发生变更时，本人将及时更新，否则自行承担相应后果。 "
                    )
                  ])
                ]),
                _c(
                  "div",
                  { staticClass: "sureBtn" },
                  [
                    _c(
                      "van-button",
                      {
                        directives: [
                          {
                            name: "throttle",
                            rawName: "v-throttle",
                            value: [_vm.onSubmit, "click", 3000],
                            expression: "[onSubmit, `click`, 3000]"
                          }
                        ],
                        class: { cancelBtn: !_vm.isDisabled2 },
                        attrs: {
                          disabled: !_vm.isDisabled2,
                          round: "",
                          block: "",
                          color: "#E12817",
                          "native-type": "button"
                        }
                      },
                      [_vm._v("提交")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        : _vm._e(),
      _vm.showIndexOther
        ? [
            _c("div", { staticClass: "emptyDiv" }),
            _c(
              "van-form",
              [
                _c("van-field", {
                  attrs: {
                    name: "familyName",
                    label: "拼音/英语姓",
                    placeholder: "请输入拼音/英语姓",
                    "input-align": "right",
                    formatter: _vm.formatterEntry,
                    rules: [{ required: true, trigger: "onSubmit" }]
                  },
                  on: { focus: _vm.changeWarnColor },
                  model: {
                    value: _vm.personalObj.familyName,
                    callback: function($$v) {
                      _vm.$set(_vm.personalObj, "familyName", $$v)
                    },
                    expression: "personalObj.familyName"
                  }
                }),
                _c("van-field", {
                  attrs: {
                    name: "lastName",
                    label: "拼音/英语名",
                    placeholder: "请输入拼音/英语名",
                    "input-align": "right",
                    formatter: _vm.formatterEntry,
                    rules: [{ required: true, trigger: "onSubmit" }]
                  },
                  on: { focus: _vm.changeWarnColor },
                  model: {
                    value: _vm.personalObj.lastName,
                    callback: function($$v) {
                      _vm.$set(_vm.personalObj, "lastName", $$v)
                    },
                    expression: "personalObj.lastName"
                  }
                }),
                _c("van-field", {
                  attrs: {
                    readonly: "",
                    clickable: "",
                    name: "bornCountry",
                    value: _vm.personalObj.bornCountry,
                    label: "出生国家/地区",
                    placeholder: "请选择",
                    "right-icon": "arrow",
                    "input-align": "right",
                    rules: [{ required: true, trigger: "onSubmit" }]
                  },
                  on: {
                    click: function($event) {
                      return _vm.choiceMyCountry("01")
                    }
                  }
                }),
                _vm.personalObj.bornCountryF == "0"
                  ? _c("van-field", {
                      attrs: {
                        name: "bornCountryEN",
                        label: "出生国家/地区(英文) ",
                        placeholder: "请输入出生国家/地区(英文)",
                        "input-align": "right",
                        formatter: _vm.formatterEntry
                      },
                      on: { focus: _vm.changeWarnColor },
                      model: {
                        value: _vm.personalObj.bornCountryEN,
                        callback: function($$v) {
                          _vm.$set(_vm.personalObj, "bornCountryEN", $$v)
                        },
                        expression: "personalObj.bornCountryEN"
                      }
                    })
                  : _vm._e(),
                _c("div", { staticClass: "emptyDiv" }),
                _c("van-field", {
                  attrs: {
                    readonly: "",
                    clickable: "",
                    name: "liveCountry",
                    value: _vm.personalObj.liveCountry,
                    label: "现居国家/地区",
                    "right-icon": "arrow",
                    placeholder: "请选择",
                    "input-align": "right",
                    rules: [{ required: true, trigger: "onSubmit" }]
                  },
                  on: {
                    click: function($event) {
                      return _vm.choiceMyCountry("02")
                    }
                  }
                }),
                _vm.showProvince
                  ? _c("van-field", {
                      attrs: {
                        readonly: "",
                        clickable: "",
                        name: "liveProvince",
                        value: _vm.personalObj.liveProvince,
                        label: "现居省市县/区",
                        placeholder: "请选择",
                        "input-align": "right",
                        "right-icon": "arrow",
                        rules: [{ required: true, trigger: "onSubmit" }]
                      },
                      on: { click: _vm.onArea }
                    })
                  : _vm._e(),
                _vm.showProvince
                  ? _c("van-field", {
                      attrs: {
                        name: "address",
                        rows: "2",
                        autosize: "",
                        type: "textarea",
                        maxlength: "50",
                        placeholder: "请输入详细地址",
                        formatter: _vm.formatterMultip,
                        rules: [{ required: true, trigger: "onSubmit" }],
                        "show-word-limit": ""
                      },
                      on: { focus: _vm.changeWarnColor },
                      model: {
                        value: _vm.personalObj.address,
                        callback: function($$v) {
                          _vm.$set(_vm.personalObj, "address", $$v)
                        },
                        expression: "personalObj.address"
                      }
                    })
                  : _vm._e(),
                _c("div", { staticClass: "emptyDiv" }),
                _c("van-field", {
                  attrs: {
                    name: "liveCityEN",
                    label: "现居城市(英文)",
                    placeholder: "请输入现居城市",
                    "input-align": "right",
                    formatter: _vm.formatterEntry,
                    rules: [{ required: true, trigger: "onSubmit" }]
                  },
                  on: { focus: _vm.changeWarnColor },
                  model: {
                    value: _vm.personalObj.liveCityEN,
                    callback: function($$v) {
                      _vm.$set(_vm.personalObj, "liveCityEN", $$v)
                    },
                    expression: "personalObj.liveCityEN"
                  }
                }),
                _c("van-field", {
                  attrs: {
                    name: "addressEN",
                    rows: "2",
                    autosize: "",
                    type: "textarea",
                    maxlength: "50",
                    formatter: _vm.formatteEntip,
                    placeholder: "请输入详细地址(英文/拼音)",
                    rules: [{ required: true, trigger: "onSubmit" }],
                    "show-word-limit": ""
                  },
                  on: { focus: _vm.changeWarnColor },
                  model: {
                    value: _vm.personalObj.addressEN,
                    callback: function($$v) {
                      _vm.$set(_vm.personalObj, "addressEN", $$v)
                    },
                    expression: "personalObj.addressEN"
                  }
                }),
                _c("div", { staticClass: "emptyDiv" }),
                _c(
                  "div",
                  { staticClass: "addTaxCountry" },
                  [
                    _vm._l(_vm.chins, function(item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "taxCountryList" },
                        [
                          _c("div", { staticClass: "taxCountryList__title" }, [
                            _c("div", [
                              _vm._v("税收居民国" + _vm._s(index + 1))
                            ]),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.chins.length > 1,
                                    expression: "chins.length > 1"
                                  }
                                ],
                                staticClass: "setIcon",
                                on: {
                                  click: function($event) {
                                    return _vm.deleteTaxModule(index)
                                  }
                                }
                              },
                              [_c("van-icon", { attrs: { name: "delete-o" } })],
                              1
                            )
                          ]),
                          _c(
                            "div",
                            { staticClass: "taxCountryList__det" },
                            [
                              _c("van-field", {
                                attrs: {
                                  readonly: "",
                                  clickable: "",
                                  name: "taxCountry" + index,
                                  value: item.nameCountry,
                                  label: "税收居民国家",
                                  placeholder: "请选择",
                                  "input-align": "right",
                                  "right-icon": "arrow",
                                  rules: [
                                    { required: true, trigger: "onSubmit" }
                                  ]
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.showTaxDetail("1:" + index)
                                  }
                                }
                              }),
                              _c("van-field", {
                                attrs: {
                                  readonly: "",
                                  clickable: "",
                                  name: "isTaxNum" + index,
                                  value: item.isTaxNumber,
                                  label: "是否存在纳税人识别号",
                                  placeholder: "请选择",
                                  "input-align": "right",
                                  "right-icon": "arrow",
                                  rules: [
                                    { required: true, trigger: "onSubmit" }
                                  ]
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.showTaxNumDet(index)
                                  }
                                }
                              }),
                              item.chooseTaxRegisterNum == "1"
                                ? _c("van-field", {
                                    staticClass: "customIcon",
                                    attrs: {
                                      name: "taxNumber" + index,
                                      label: "纳税人识别号",
                                      placeholder: "请输入纳税人识别号",
                                      "input-align": "right",
                                      "left-icon": "question-o",
                                      formatter: _vm.formatterMultip,
                                      rules: [
                                        { required: true, trigger: "onSubmit" }
                                      ]
                                    },
                                    on: {
                                      focus: _vm.changeWarnColor,
                                      "click-left-icon": _vm.searchTaxDes
                                    },
                                    model: {
                                      value: item.taxRegisterNo,
                                      callback: function($$v) {
                                        _vm.$set(item, "taxRegisterNo", $$v)
                                      },
                                      expression: "item.taxRegisterNo"
                                    }
                                  })
                                : _vm._e(),
                              item.chooseTaxRegisterNum == "0"
                                ? _c("van-field", {
                                    attrs: {
                                      name: "taxNotReason" + index,
                                      rows: "2",
                                      autosize: "",
                                      type: "textarea",
                                      maxlength: "50",
                                      placeholder: "请输入不能取得识别号原因",
                                      formatter: _vm.formatterMultip,
                                      rules: [
                                        { required: true, trigger: "onSubmit" }
                                      ],
                                      "show-word-limit": ""
                                    },
                                    on: { focus: _vm.changeWarnColor },
                                    model: {
                                      value: item.nullReason,
                                      callback: function($$v) {
                                        _vm.$set(item, "nullReason", $$v)
                                      },
                                      expression: "item.nullReason"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      )
                    }),
                    _c(
                      "div",
                      { staticClass: "addTaxList" },
                      [
                        _c("van-icon", {
                          staticClass: "iconStyle",
                          attrs: { name: "add-o" }
                        }),
                        _c("span", { on: { click: _vm.addTaxPersonC } }, [
                          _vm._v("添加税收居民国")
                        ])
                      ],
                      1
                    )
                  ],
                  2
                ),
                _c("div", { staticClass: "emptyDiv" }),
                _c("upload-file", {
                  ref: "uploadFile",
                  attrs: { uploadTitle: _vm.uploadHead, certUploadType: "1" },
                  on: { imgList: _vm.closeMain }
                }),
                _c("div", { staticClass: "aboutStatement" }, [
                  _c("div", { staticClass: "aboutSure" }, [
                    _vm._v(
                      " 本人确认信息真实、准确和完整，且当上述信息发生变更时，本人将及时更新，否则自行承担相应后果。 "
                    )
                  ])
                ]),
                _c(
                  "div",
                  { staticClass: "sureBtn" },
                  [
                    _c(
                      "van-button",
                      {
                        directives: [
                          {
                            name: "throttle",
                            rawName: "v-throttle",
                            value: [_vm.onSave, "click", 3000],
                            expression: "[onSave, `click`, 3000]"
                          }
                        ],
                        staticClass: "btn-right",
                        attrs: {
                          round: "",
                          block: "",
                          color: "#E12817",
                          "native-type": "button"
                        }
                      },
                      [_vm._v("保存")]
                    ),
                    _c(
                      "van-button",
                      {
                        directives: [
                          {
                            name: "throttle",
                            rawName: "v-throttle",
                            value: [_vm.onSubmit, "click", 3000],
                            expression: "[onSubmit, `click`, 3000]"
                          }
                        ],
                        class: { cancelBtn: !_vm.isDisabled3 },
                        attrs: {
                          disabled: !_vm.isDisabled3,
                          round: "",
                          block: "",
                          color: "#E12817",
                          "native-type": "button"
                        }
                      },
                      [_vm._v("提交")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        : _vm._e(),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.areaShowPicker,
            callback: function($$v) {
              _vm.areaShowPicker = $$v
            },
            expression: "areaShowPicker"
          }
        },
        [
          _c("van-picker", {
            attrs: { "show-toolbar": "", columns: _vm.locationList },
            on: {
              change: _vm.onChangeArea,
              confirm: _vm.onConfirmArea,
              cancel: function($event) {
                _vm.areaShowPicker = false
              }
            }
          })
        ],
        1
      ),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.showTaxCountry,
            callback: function($$v) {
              _vm.showTaxCountry = $$v
            },
            expression: "showTaxCountry"
          }
        },
        [
          _c("van-area", {
            attrs: { "area-list": _vm.areaList },
            on: {
              confirm: _vm.getTaxCountry,
              cancel: function($event) {
                _vm.showTaxCountry = false
              }
            }
          })
        ],
        1
      ),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.showTaxNum,
            callback: function($$v) {
              _vm.showTaxNum = $$v
            },
            expression: "showTaxNum"
          }
        },
        [
          _c("van-picker", {
            attrs: { "show-toolbar": "", columns: _vm.showColumn },
            on: {
              confirm: _vm.getChoice,
              cancel: function($event) {
                _vm.showTaxNum = false
              }
            }
          })
        ],
        1
      ),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.countryShowPicker,
            callback: function($$v) {
              _vm.countryShowPicker = $$v
            },
            expression: "countryShowPicker"
          }
        },
        [
          _c("van-picker", {
            attrs: {
              "show-toolbar": "",
              columns: _vm.countryList,
              "value-key": "chnTrivialName"
            },
            on: {
              confirm: _vm.onConfirmCountry,
              cancel: function($event) {
                _vm.countryShowPicker = false
              }
            }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }